import TheGrid from '@/views/dealers/operator_groups/grid'
import Edit from '@/views/dealers/operator_groups/edit'

export default {
  path: '/dealers/operator_groups',
  redirect: '/dealers/operator_groups/index',
  name: 'operatorGroups',
  meta: {
    auth: {
      redirect: {
        name: 'operatorGroups.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'DSR'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'operatorGroups.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'operatorGroups.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'operatorGroups.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
